export default __webpack_public_path__ + "static/media/Ronaldo Aguiar_.54844f26.png";